import React from 'react';

const FormSelector = ({ options, defaultValue, handleFormSelector }) => {
    const [value, setValue] = React.useState(defaultValue);
    const getSelectedOption = event => {
        const { value } = event.currentTarget;
        setValue(value);
        handleFormSelector && handleFormSelector(value);
    };

    return (
        <select defaultValue={value} onChange={getSelectedOption}>
            {
                options && options.map(option =>
                    <option key={option.value} value={option.value}>{option.value}</option>
                )
            }
        </select>
    );
};
export default FormSelector;


// WEBPACK FOOTER //
// ./src/App/components/FormSelector.js